import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "d-flex flex-stack" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "symbol symbol-60px me-5" }
const _hoisted_5 = { class: "d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3" }
const _hoisted_6 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary fs-5"
}
const _hoisted_7 = { class: "text-muted fw-bold" }
const _hoisted_8 = { class: "ms-1" }
const _hoisted_9 = {
  type: "button",
  class: "\n              btn btn-sm btn-icon btn-color-primary btn-active-light-primary\n            ",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "d-flex flex-column w-100 mt-12" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text-dark me-2 fw-bolder pb-3" }, " Progress ", -1)
const _hoisted_13 = { class: "progress h-5px w-100" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column mt-10\"><div class=\"text-dark me-2 fw-bolder pb-4\">Team</div><div class=\"d-flex\"><a href=\"#\" class=\"symbol symbol-35px me-2\" data-bs-toggle=\"tooltip\" title=\"Ana Stone\"><img src=\"media/avatars/150-1.jpg\" alt=\"\"></a><a href=\"#\" class=\"symbol symbol-35px me-2\" data-bs-toggle=\"tooltip\" title=\"Mark Larson\"><img src=\"media/avatars/150-4.jpg\" alt=\"\"></a><a href=\"#\" class=\"symbol symbol-35px me-2\" data-bs-toggle=\"tooltip\" title=\"Sam Harris\"><img src=\"media/avatars/150-8.jpg\" alt=\"\"></a><a href=\"#\" class=\"symbol symbol-35px\" data-bs-toggle=\"tooltip\" title=\"Alice Micto\"><img src=\"media/avatars/150-9.jpg\" alt=\"\"></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown2 = _resolveComponent("Dropdown2")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", {
              class: [`bg-${_ctx.color}-light`, "symbol-label"]
            }, [
              _createVNode("img", {
                src: _ctx.image,
                class: "h-50 align-self-center",
                alt: ""
              }, null, 8, ["src"])
            ], 2)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("a", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.date), 1)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("button", _hoisted_9, [
            _createVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
            ])
          ]),
          _createVNode(_component_Dropdown2)
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("div", {
            class: [`bg-${_ctx.color}`, "progress-bar"],
            role: "progressbar",
            style: `width: ${_ctx.progress}%`,
            "aria-valuenow": _ctx.progress,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, null, 14, ["aria-valuenow"])
        ])
      ]),
      _hoisted_14
    ])
  ], 2))
}